import { useEffect } from 'react';

/**
 * Let this page follow the phone's light or dark setting while it is mounted.
 *
 * A class on <html> rather than on the page's own wrapper, so the dialogs and
 * toasts it opens — portalled outside the wrapper — follow too. Pages that do
 * not call this stay light, whatever the phone says: see the note on
 * `.theme-auto` in theme/tailwind.css.
 */
export const useSystemTheme = () => {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('theme-auto');
    return () => root.classList.remove('theme-auto');
  }, []);
};
